import React from 'react';
import { Formik, Form, Field } from 'formik';
import { WizardContext } from 'react-albus';
import { monthlyExpenseValidation } from '../validations';
import { saveItem, getExistingData } from '../helper';
import FormikMaskedInput from '../../CommonComponents/FormikMaskedInput';
import { currencyMask } from '../../CommonComponents/MaskedInput';
import Header from '../Components/Header';
import WizardProgress from '../Components/WizardProgress';

interface Props {
  wizard: WizardContext;
}

const MonthlyExpenses: React.FC<Props> = ({ wizard }) => {
  const { next } = wizard;
  const { MonthlyExpense } = getExistingData();

  return (
    <div id="ExpressWizard_Input_Retirement" className="adv-form ExpressWizard">
      <Header wizard={wizard} />
      <WizardProgress wizard={wizard} />
      <Formik
        initialValues={{
          MonthlyExpense: MonthlyExpense || '',
        }}
        validationSchema={monthlyExpenseValidation}
        onSubmit={values => {
          saveItem(values);
          next();
        }}
      >
        {({ errors, touched }) => (
          <Form>
            <ul className="questions">
              <li style={{ display: 'block' }}>
                <ul className="horizontal-layout">
                  <li>
                    <label>What are your monthly expenses?</label>
                    <div
                      className={`input underline ${
                        errors.MonthlyExpense && touched.MonthlyExpense ? 'invalid' : ''
                      }`}
                      style={{ width: '228px', float: 'none', margin: '0 auto' }}
                    >
                      <i style={{ marginRight: '10px' }}>$</i>
                      <Field
                        className="input-container"
                        name="MonthlyExpense"
                        component={FormikMaskedInput}
                        mask={currencyMask}
                        placeholder="0"
                        style={{ width: '160px' }}
                      />
                    </div>
                  </li>
                </ul>
              </li>
            </ul>
            <div className="action">
              <button type="submit" className="primary flat next">
                Next
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default MonthlyExpenses;
